export default __webpack_public_path__ + "static/media/security.d477e41c.jpg";